// extracted by mini-css-extract-plugin
export default {"input":"HeaderSearch_input__Nqk20"};